import { render, staticRenderFns } from "./MobileCollapseSection.vue?vue&type=template&id=38e51294&scoped=true&"
import script from "./MobileCollapseSection.vue?vue&type=script&lang=js&"
export * from "./MobileCollapseSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e51294",
  null
  
)

export default component.exports